// Lädt die eigenen API-Permissions (Action-Keys) und stellt einen `can()`
// Helper bereit. Wird in jeder Seite genutzt, die granular UI-Elemente
// ein-/ausblenden möchte (z. B. „+ Neues System" nur wenn `systems.create`).
import { useEffect, useState, useCallback } from 'react';
import { authFetch } from '../lib/auth-fetch';
import { useAuth } from '../contexts/AuthContext';

let _cachedActions = null;     // Modul-private Cache (eine Session)
let _cachedRole = null;

export function usePermissions() {
  const { user } = useAuth();
  const [actions, setActions] = useState(() =>
    _cachedActions && _cachedRole === user?.role ? _cachedActions : null
  );

  useEffect(() => {
    if (!user) { setActions(null); return; }
    // Admin & Customer früh kurzschließen — Admin hat alles, Customer nichts.
    if (user.role === 'admin') {
      setActions(new Set(['*']));   // Wildcard
      _cachedActions = new Set(['*']); _cachedRole = 'admin';
      return;
    }
    if (user.role === 'customer') {
      setActions(new Set());
      return;
    }
    if (_cachedActions && _cachedRole === user.role) {
      setActions(_cachedActions);
      return;
    }
    (async () => {
      const r = await authFetch('/api/permissions/me');
      if (!r.ok) { setActions(new Set()); return; }
      const d = await r.json();
      const set = new Set(d.actions || []);
      _cachedActions = set; _cachedRole = user.role;
      setActions(set);
    })();
  }, [user]);

  const can = useCallback((key) => {
    if (!actions) return false;
    if (actions.has('*')) return true;
    return actions.has(key);
  }, [actions]);

  return { can, ready: actions !== null, role: user?.role };
}

// Manuell invalidieren — z. B. nach Rollen-Update im Admin-Dashboard.
export function invalidateCachedPermissions() {
  _cachedActions = null;
  _cachedRole = null;
}
